import React, { useState, useEffect } from "react";
import s from "./FormRemitos.module.css";
// services
import deliveryServices from "../../../../api/delivery/DeliveryService";
import { useDispatch, useSelector } from "react-redux";
import { today } from "../../../../helpers/today";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// Material imports
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FirstStepper from "./Steppers Refactor/FirstStepper";
import SecondStepper from "./Steppers Refactor/SecondStepper";
import ConfirmationStepper from "./Steppers Refactor/ConfirmStepper";
// Helpers
import useTranslationException from "../../../../helpers/exceptions";

// ========================== | Form Remitos | =================================

export default function FormRemitos({
  sort,
  getData,
  edit,
  setEdit,
  setItems,
  actualPage,
  pageSize,
}) {
  // Section: Hooks
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);
  // Section: Redux
  const { textColor } = useSelector((state) => state.local);
  const currentUser = useSelector((state) => state.gamma.logged_user);
  const organizationNoa = useSelector((state) => state.gamma.noaOrganization)
  // Section: States
  const [order, setOrder] = useState(null);
  const [passingType, setPassingType] = useState(0);
  const [detailsDelivery, setDetailsDelivery] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [disabledNext, setDisabledNext] = useState(false);
  const [destino, setDestino] = useState("proveedor");
  // Section using reference

  /* NOTE:
   *  Identify the each prop of the object
   *  Get the corresponding data
   *  Send the correct from to the ep
   *  Verify all the data is correct
   * */
  // Section: Form data
  const [form, setForm] = useState(edit.status ?
    editDeliveryNoteForm(edit, currentUser) :
    newDeliveryNoteForm(currentUser, organizationNoa)
  );

  // Section: Handlers
  const handleConfirm = () => {

    let details = form?.detailList?.map((detail) => ({
      id: detail.id,
      amount: detail.amount,
      nroCouponFrom: detail.nroCouponFrom,
      nroCouponTo: detail.nroCouponTo,
      gameId: detail.gameId ?? detail.game.id,
      raffleId: detail.raffleId ?? detail.raffle.id,
    }));
    Swal.fire({
      title: t("deliveryConfirm"),
      text: t("deliveryConfirmText"),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#00A36C",
      cancelButtonColor: "#d33",
      confirmButtonText: t("confirm"),
      cancelButtonText: t("cancel"),
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        let payload = {
          ...form,
          id: edit.item.id,
          state: "Activo",
          detailList: [...details],
          storePassingType: ["", "SUP_LOT", "LOT_AGE", "AGE_LOT", "LOT_SUP"][
            passingType
          ],
          pageNumber: 1,
        };
        deliveryServices
          .createDeliveryNote(payload)
          .then((response) => {
            Swal.fire(
              t("deliveryConfirmDone"),
              t("deliveryConfirmDoneText"),
              "success",
            );
            return response;
          })
          .then(() => {
            deliveryServices
              .getDeliveryNote(actualPage, pageSize, dispatch, sort)
              .then((response) => setItems(response.content))
              .then(() => {
                setLoading(false);
                setEdit({ status: false, item: {} });
                setDetailsDelivery([]);
                setOrder(null);
                if (edit.item.type === "Salida") {
                  navigate(`../remitos/impreso/${edit.item.id}`);
                } else {
                  navigate("../remitos");
                }
              });
          })
          .catch((e) => {
            const responseMessage = e.response.data.title
            const errorMessage = responseMessage === "LOTTERY_STOCK_ITEM_ALREADY_FOUND" ?
              "Ya existen cupones en stock de los detalles seleccionados." :
              "Ha ocurrido un error, vuelva a intentar luego."
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              errorMessage,
              t("sorryErrorOcurred"),
            );
            setLoading(false);
          });
      }
    });
  };

  const handleSave = () => {
    setLoading(true);
    let details = form?.detailList?.map((detail) => ({
      id: detail.id,
      amount: detail.amount,
      nroCouponFrom: detail.nroCouponFrom,
      nroCouponTo: detail.nroCouponTo,
      gameId: detail?.gameId ?? detail?.game.id,
      raffleId: detail?.raffleId ?? detail?.raffle.id,
    }));

    let payload = {
      ...form,
      id: edit.item.id,
      state: "Activo",
      detailList: [...details],
      storePassingType: ["", "SUP_LOT", "LOT_AGE", "AGE_LOT", "LOT_SUP"][
        passingType
      ],
    };

    // deliveryServices.createDeliveryNote(payload)
    //   .then(response => {
    //     Swal.fire(
    //       t('deliverySaveDone'),
    //       t('youCanContinue'),
    //       'success',
    //     )
    //     setEdit({ item: { ...edit.item, id: response.id }, status: true })
    //   })
    //   .then(() => {
    //     deliveryServices.getDeliveryNote(actualPage, pageSize, dispatch, sort)
    //       .then(response => setItems(response.content))
    //       .then(() => {
    //         setLoading(false)
    //         setActiveStep(activeStep + 1)
    //       });
    //   })
    //   .catch((e) => {
    //     showExpetion.showErrorModalForServiceException(e, { icon: "warning" }, t('anErrorOccurred,TryAgain'), t('sorryErrorOcurred'));
    //     setLoading(false);
    //   })
    setLoading(false);
    setActiveStep(activeStep + 1);
    setLoading(false);
  };

  function handleEdit() {
    let details = form?.detailList?.map((detail) => {
      return {
        id: detail.id,
        amount: detail.amount,
        nroCouponFrom: detail.nroCouponFrom,
        nroCouponTo: detail.nroCouponTo,
        gameId: detail.gameId ?? detail.game.id,
        raffleId: detail.raffleId ?? detail.raffle.id,
      };
    });    

    if (
      JSON.stringify(form.detailList) === JSON.stringify(details) &&
      activeStep !== 0
    ) {
      setActiveStep(activeStep + 1);
    } else {
      setLoading(true);
      Swal.fire({
        title: t("deliverySave"),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#00A36C",
        cancelButtonColor: "#d33",
        confirmButtonText: t("confirm"),
        cancelButtonText: t("cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          let payload = {
            ...form,
            id: edit.item.id,
            state: "En Proceso",
            detailList: details ? [...details] : [],
            storePassingType: ["", "SUP_LOT", "LOT_AGE", "AGE_LOT", "LOT_SUP"][
              passingType
            ],
          };
          // deliveryServices.createDeliveryNote(payload)
          //   .then((res) => {
          //     Swal.fire(
          //       t('deliverySaveDone'),
          //       t('deliverySaveDoneText'),
          //       'success'
          //     )
          //     setEdit({
          //       status: true,
          //       item: res,
          //     })
          //   })
          //   .then(() => {
          //     deliveryServices.getDeliveryNote(actualPage, pageSize, dispatch, sort)
          //       .then(response => setItems(response.content))
          //       .then(() => {
          //         setLoading(false)
          //         setActiveStep(activeStep + 1)
          //       });
          //   })
          //   .catch((e) => {
          //     showExpetion.showErrorModalForServiceException(e, { icon: "warning" }, t('tryInAMoment'), t('sorryErrorOcurred'));
          //     setLoading(false);
          //   })
          setForm(payload);
          setLoading(false);
          setActiveStep(activeStep + 1);
        } else {
          setLoading(false);
        }
      });
    }
  };

  const handleExit = () => {
    setEdit({ status: false, item: {} });
    navigate("../remitos");
    setDetailsDelivery([]);
    setOrder(null);
    getData();
  };

  // Section: Effects
  useEffect(() => {
    if (edit.status && edit?.item?.detailList?.length) {
      let details = edit?.item?.detailList?.map((detail) => {
        return {
          id: detail.id,
          amount: detail.amount,
          nroCouponFrom: detail.nroCouponFrom,
          nroCouponTo: detail.nroCouponTo,
          gameId: detail?.gameId ?? detail.game.id,
          raffleId: detail?.raffleId ?? detail.raffle.id,
        };
      });
      setDetailsDelivery(edit?.item?.detailList);
      setForm({ ...form, detailList: details });
    }
  }, [edit, form]);

  useEffect(() => {
    if (!edit.status) {
      if (form.type === "Salida") {
        deliveryServices
          .getSequency()
          .then((res) => {
            setForm({
              ...form,
              orderId: 0,
              nroOutput: res,
              nroInput: undefined,
              date: new Date().toISOString(),
            });
          })
          .catch((e) => console.log(e));
      } else {
        setForm({
          ...form,
          orderId: 0,
          nroOutput: undefined,
          nroInput: undefined,
          date: new Date().toISOString(),
        });
      }
    }
  }, [form.type]);

  useEffect(() => {
    if (form !== null) {
      if (form.type === "Salida") {
        if (form.agencyId) {
          setPassingType(2);
        } else if (form.supplierId) {
          setPassingType(4);
        } else {
          setPassingType(0);
        }
      } else {
        if (form.agencyId) {
          setPassingType(3);
        } else if (form.supplierId) {
          setPassingType(1);
        } else {
          setPassingType(0);
        }
      }
    }
  }, [form]);

  useEffect(() => {
    if (form !== null) {
      setDisabledNext(() => {
        const shouldDisabledNext =
          loading ||
          (activeStep === 1 && form?.detailList?.length === 0) ||
          !(
            (form.supplierId || form.agencyId) &&
            (form.nroInput || form.nroOutput)
          );

        return shouldDisabledNext;
      });
    }
  }, [activeStep, form, loading]);

  return (
    <Grid container className={s.container}>
      <Grid item xs={10} className={s.titleContainer}>
        <ArrowBackIcon
          sx={{ color: "primary.main", fontSize: "2rem" }}
          onClick={() => handleExit()}
          className={s.arrow}
        />
        <h4>{edit.status ? t("editDeliveryNote") : t("createDeliveryNote")}</h4>
      </Grid>
      <Grid container item xs={11} className={s.stepperContainer}>
        <Stepper
          alternativeLabel
          activeStep={activeStep}
          sx={{ width: "100%" }}
        >
          <Step>
            <StepButton color="inherit">{t("deliveryNoteHead")}</StepButton>
          </Step>
          <Step>
            <StepButton color="inherit">{t("details")}</StepButton>
          </Step>
          <Step>
            <StepButton color="inherit">{t("confirm")}</StepButton>
          </Step>
        </Stepper>
      </Grid>

      {form &&
        <Grid container item xs={10} className={s.data}>
          {activeStep === 0 ? (
            <FirstStepper
              form={form}
              setForm={setForm}
              edit={edit}
              order={order}
              setOrder={setOrder}
              destino={destino}
              setDestino={setDestino}
            />
          ) : activeStep === 1 ? (
            <SecondStepper
              form={form}
              setForm={setForm}
              edit={edit}
              raffles={detailsDelivery}
              setRaffles={setDetailsDelivery}
              passingType={passingType}
              order={order}
              destino={destino}
            />
          ) : (
            <ConfirmationStepper form={form} raffles={detailsDelivery} />
          )}
          <Grid item xs={12} className={s.stepperButtons}>
            <Button
              size="small"
              variant="contained"
              onClick={() =>
                setActiveStep(activeStep === 0 ? handleExit() : activeStep - 1)
              }
              className={s.button}
              sx={{ backgroundColor: "primary.main", color: textColor }}
            >
              {t("back")}
            </Button>
            <Button
              size="small"
              disabled={disabledNext}
              variant="contained"
              onClick={() => {
                if (edit.status) {
                  if (activeStep === 0) {
                    handleEdit();
                  } else if (activeStep === 1) {
                    handleEdit();
                  } else if (activeStep === 2) {
                    handleConfirm();
                  }
                } else {
                  if (activeStep === 0) {
                    handleSave();
                  } else if (activeStep === 1) {
                    handleEdit();
                  } else if (activeStep === 2) {
                    handleConfirm();
                  }
                }
              }}
              className={s.button}
              sx={{ backgroundColor: "primary.main", color: textColor }}
            >
              {loading ? (
                <CircularProgress />
              ) : activeStep === 2 ? (
                t("confirm")
              ) : (
                t("next")
              )}
            </Button>
          </Grid>
        </Grid>
      }
    </Grid>
  );
}

/*
 * This function loads the form whenever the type is editing an existing remito
 * @param { any } edit - The data of the remito that is going to be editted
 * @param { any } currentUser - The current user data
 * */
function editDeliveryNoteForm(edit, currentUser) {
  return {
    organizationId: edit.item.organizationId,
    organizationName: edit.item.organizationName,
    lotteryId: edit.item.lotteryId,
    lotteryName: edit.item.lotteryName,
    type: edit.item.type,
    nroInput: edit.item.nroInput * 1,
    nroOutput: edit.item.nroOutput * 1,
    agencyId: edit.item.agencyId,
    agencyName: edit.item.agencyName,
    supplierId: edit.item.supplierId,
    supplierName: edit.item.supplierName,
    orderId: edit.item.orderId,
    date: edit.status,
    userNameLastname: currentUser.memberships[0]?.organization?.name,
    storeRemit: edit.item.storeRemit,
    storeReceptor: edit.item.storeReceptor,
    observations: edit.item.observations,
    carrierId: edit.item.carrierId,
    state: edit.item.state,
    detailList: edit.item.detailList,
  }
}

/* This fucntion loads the form when the state is new remito
 * @pram { any } currentUser - The current user
 * */
function newDeliveryNoteForm(currentUser, organizationNoa) {

  return {
    // TODO: Cambiar lotteryId por redux state -> raffleLotteries[0].id
    lotteryId: currentUser?.memberships[0]?.organization?.id,
    lotteryName: currentUser?.memberships[0]?.organization?.name,
    type: "Entrada",
    nroInput: undefined,
    nroOutput: undefined,
    agencyId: "",
    agencyName: "",
    supplierId: "",
    supplierName: "",
    orderId: "",
    date: new Date().toISOString(),
    settlementDate: new Date().toISOString(),
    userNameLastname: "",
    storeRemit: "",
    storeReceptor: "",
    observations: "",
    carrierId: "",
    state: "",
    organization: organizationNoa,
    detailList: [],
  }
}
